<!-- 市民主页 -->
<template>
    <component :ref="activeName"
               hide-navigate
               :is="activeName"></component>
</template>

<script>
import current from "../seal/current.vue";
import personal from "../sign/signatory.vue";

export default {
    components: { current, personal },
    computed: {
        quser () {
            return this.$store.getters.quser;
        },
        isCompany () {
            return this.$store.getters.isPersonal;
        },
        activeName () {
            return this.isCompany ? 'current' : 'personal';
        }
    }
};
</script>

<style lang="less" scoped>
</style>
